export type DeviceDetailResponse = {
  error: boolean;
  results: {
    device_os_version: string;
    iphone_device_family: number;
    device_name: string;
    is_greater_or_equal_to_9: boolean;
    is_desktop_mode: boolean;
    show_ios_8_guide_after_install: boolean;
    show_overwrite_install_link: boolean;
    email: string;
  };
};

export const isUser = (arg: User | Group): arg is User => {
  return 'profile_icon' in arg;
};

export type User = {
  id: number;
  name: string;
  profile_icon: string;
};

export type Group = {
  id: number;
  name: string;
  description: string;
};

type Application = {
  file: string;
  file_size: number;
  icon: string;
  md5: string;
  message: string;
  name: string;
  package_name: string;
  path: string;
  raw_sdk_version: string | null;
  revision: number;
  sdk_version: number;
  secret: string;
  signature: string;
  target_sdk_version: string;
  user: User | Group;
  version_code: string;
  version_name: string;
  updated_at: number;
};

type Distribution = {
  access_key: string;
  title: string;
  release_note: string;
  max_members: number;
  updated_at: number;
  flags: {
    norobot: boolean;
  };
  application: Application;
};

export type AvailableAppsResponse = {
  error: boolean;
  results?: {
    distributions: Distribution[];
    my_apps: Application[];
  } | null;
};

export type DeviceEmailResponse = {
  error: boolean;
  results: {
    email: string;
  };
};
